import { Observable } from 'rxjs';
import { MemberAddress } from 'src/app/models/address';
import { MemberPhone } from 'src/app/models/phone';
import { Product } from 'src/app/models/product';
import { TelephonyContext } from 'src/app/models/telephonyv2';
import { Member, MemberContext, MMRRecord, SessionStatus } from 'src/app/models/member';
import { ICommand, ICommandsWrapper } from 'src/app/services/task/command/command.models';


export class ClearMemberSessionAction {
    static readonly type = '[Member Session] Clear';

    constructor(public options?: IClearMemberSessionActionOptions) { }
}

export interface IClearMemberSessionActionOptions {
    keepContextProgress?: boolean;
}

export interface IMemberStateModel {
    sessionsTracker: {
        contexts?: TelephonyContext[];
    };
    currentSession: {
        initialized?: boolean;
        base64?: string;
        legacyBase64?: string;
        tenantId?: string;
        memberContext?: MemberContext;
        mmr?: MMRRecord;
        memberId?: string;
        previousTenantId?: string;
        products?: Product[];
        addresses?: MemberAddress[];
        phones?: MemberPhone[];
        $previousState?: IMemberStateModel;
        trackingCommands: ICommand[];
    };
}

export interface MemberTasksStateModel extends ICommandsWrapper {
    commands: ICommand[];
}

export interface IMemberRetrieval {
    getCurrentMember(): Observable<Member>;
}

export interface IMemberCallManager {
    setOnCall(payload: boolean);
}

export interface IMemberSessionManager {
    setSessionStatus(payload: SessionStatus);
}

// #region Telephony
 export interface MemberSessionTrackerStateModel {
    contexts?: TelephonyContext[];
}

export interface ISurveyInfoViewModel {
    telephonyId: string;
    memberId?: string;
    orchestrationId?: string;
    tenantId?: string;
    rating: number;
}
// #endregion

